<template>
  <div class="Sobre" v-if="!is_mobile">
    <div class="libe_home_nav animate__animated animate__fadeInDown" v-if="scroll >= 88">
      <headNav :activeNav="'Aviso'"></headNav>
    </div>
    <div class="eshoy_content_wrap">
      <div class="libe_homenav" v-if="scroll < 88 ">
        <homeNav :activeNav="'Aviso'"></homeNav>
      </div>

      <div class="lalanitaaviso_1v">
        <div class="lalanitaaviso_1vhea">Aviso Antifraude</div>
        <div class="lalanitaaviso_1vtx">
          <div class="lalanitaaviso_1vtx_s">⚠️Recuerda que en LaLANITA nunca pedimos información confidencial más allá de la necesaria para solicitar un préstamo, y esa información siempre estar protegida. Jamás contactamos por canales que no sean oficiales ❗</div>
          <div class="lalanitaaviso_1vtx_s">⚠️No solicitamos pagos por adelantado antes de pedir un préstamo o liquidar uno. Puedes liquidar el préstamo antes de la fecha de vencimiento, pero nunca cobramos comisiones o cargos de gestión, ni proporcionamos códigos QR de pago distintos a los que aparecen en la app o con algún tipo de descuento ❗</div>
          <div class="lalanitaaviso_1vtx_s">⚠️No requeremos que realice transferencias/pagos a cuentas fuera de las páginas oficiales de pago.</div>
        </div>
        <div class="lalanitaaviso_1vms">Además, te invitamos a reportar cualquier intento de fraude. Si confirmamos que la información es efectiva, recompensamos con un cupón/descuento, como agradecimiento.</div>
      </div>

      <div class="lalanitaaviso_2v">
        <div class="lalanitaaviso_2v_v">
          <div class="lalanitaaviso_2v_vh">Si recibe algun mensaje o información sospechosa de fraude, por favor, contáctenos de inmediato:</div>
          <div class="lalanitaaviso_2v_vd">
            <div class="lalanitaaviso_2v_vd_v">
              📧 Correo：servicio@lalanita.mx
            </div>
            <div class="lalanitaaviso_2v_vd_v">
              ☎️ Teléfono：5590599377
            </div>
            <div class="lalanitaaviso_2v_vd_v">
              📱
            </div>
          </div>
        </div>
        <div class="lalanitaaviso_2v_vmg">
          <img src="../assets/imgs/lalanitaaviso_2v_1.webp" alt="">
        </div>
        <div class="lalanitaaviso_2v_vmg_circle"></div>
        <div class="lalanitaaviso_2v_vmg_cicon">
          <div class="lalanitaaviso_2v_vmg_cirv">
            <img src="../assets/imgs/lalanitaaviso_2v_3.png" alt="">
          </div>
        </div>
      </div>


    </div>
    <footPage></footPage>
  </div>
  <div v-else class="mobile_viewrap">
    <div class="mobile_wrap">
      <mobNav :activeNav="activeNav"></mobNav>
    </div>
    <div class="mobhome_banner">
      <div class="lalanitaaviso_1v">
        <div class="lalanitaaviso_1vhea">Aviso Antifraude</div>
        <div class="lalanitaaviso_1vtx">
          <div class="lalanitaaviso_1vtx_s">⚠️Recuerda que en LaLANITA nunca pedimos información confidencial más allá de la necesaria para solicitar un préstamo, y esa información siempre estar protegida. Jamás contactamos por canales que no sean oficiales ❗</div>
          <div class="lalanitaaviso_1vtx_s">⚠️No solicitamos pagos por adelantado antes de pedir un préstamo o liquidar uno. Puedes liquidar el préstamo antes de la fecha de vencimiento, pero nunca cobramos comisiones o cargos de gestión, ni proporcionamos códigos QR de pago distintos a los que aparecen en la app o con algún tipo de descuento ❗</div>
          <div class="lalanitaaviso_1vtx_s">⚠️No requeremos que realice transferencias/pagos a cuentas fuera de las páginas oficiales de pago.</div>
        </div>
        <div class="lalanitaaviso_1vms">Además, te invitamos a reportar cualquier intento de fraude. Si confirmamos que la información es efectiva, recompensamos con un cupón/descuento, como agradecimiento.</div>
      </div>
    </div>

    <div class="mobile_itemimg_wrap">
      <div class="lalanitaaviso_2v">
        <div class="lalanitaaviso_2v_v">
          <div class="lalanitaaviso_2v_vh">Si recibe algun mensaje o información sospechosa de fraude, por favor, contáctenos de inmediato:</div>
          <div class="lalanitaaviso_2v_vd">
            <div class="lalanitaaviso_2v_vd_v">
              📧Correo：servicio@lalanita.mx
            </div>
            <div class="lalanitaaviso_2v_vd_v">
              ☎️Teléfono：5590599377
            </div>
            <div class="lalanitaaviso_2v_vd_v">
              📱
            </div>
          </div>
        </div>
      </div>
    </div>

    <mobFooter></mobFooter>
  </div>

</template>

<script>
  import headNav from "@/components/headNav.vue";
  import homeNav from "@/components/homeNav.vue";
  import footPage from "@/components/foot.vue";
  import "../components/scss/sobre.scss";
  import mobNav from "@/components/mobNav.vue";
  import mobFooter from "@/components/mobfooter.vue";
  import mobileOrpc from "@/mixins/index";

  export default {
    name: "Aviso",
    components: { headNav, homeNav, footPage, mobNav, mobFooter },
    mixins: [mobileOrpc],
    data() {
      return {
        activeNav: "Aviso",
        scroll: 0,
      }
    },
    mounted(){
      window.addEventListener('scroll',this.handleScroll)
      document.body.scrollTop = document.documentElement.scrollTop=0;
    },
    methods: {
      handleScroll(){
        //或者使用document.querySelector('.class或者#id').scrollTop
        this.scroll = document.documentElement.scrollTop||document.body.scrollTop
      },
    },
    //销毁,否则跳到别的路由还是会出现
    destroyed() {
      window.removeEventListener('scroll', this.handleScroll)
    }
  }
</script>

<style>
  @keyframes rotateAnimation {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
  .eshoy_about_wrap{
    width: 100%;
    height: auto;
    padding: 90px 0 140px 0;
    background: #13151A;
  }
  .eshoy_abtitle_cont{
    width: 100%;
    height: auto;
    padding-bottom: 80px;
  }
  .eshoy_abtitle_icon{
    width: 54px;
    height: 54px;
    margin: 0 auto;
  }
  .eshoy_abtitle_view{
    width: 100%;
    height: 30px;
    padding-top: 18px;
    font-size: 30px;
    font-family: MiSans-Semibold, MiSans;
    font-weight: 600;
    color: #391C10;
    line-height: 30px;
    text-align: center;
  }
  .eshoy_abtitle_icon img{
    display: block;
    width: 100%;
  }
  .eshoy_abmessage_cont{
    width: 1200px;
    height: auto;
    background: #FFFFFF;
    box-shadow: 0px 25px 50px 0px rgba(69,69,69,0.04);
    border-radius: 20px;
    border: 1px solid #EFECEA;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 63px 64px 65px 64px;
  }
  .eshoy_abmessage_title{
    width: 100%;
    height: 22px;
    font-size: 22px;
    font-family: MiSans-Semibold, MiSans;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 22px;
  }
  .eshoy_abmessage_view{
    width: 100%;
    height: auto;
    padding-top: 24px;
    font-size: 18px;
    font-family: MiSans-Regular, MiSans;
    font-weight: 400;
    color: #453D39;
    line-height: 33px;
  }
  .fotop_cont_dit_img img{
    display: block;
    width: 100%;
  }
  .eshoy_content_wrap{
    width: 100%;
    height: auto;
    position: relative;
  }
  .product_wrap{
    width: 100%;
    height: auto;
    background: #13151A;
    padding-top: 120px;
  }
  .product_cont{
    width: 1200px;
    height: auto;
    padding-bottom: 114px;
    margin: 0 auto;
  }
  .product_cont img{
    display: block;
    width: 100%;
  }
  .mobile_itemimg_wrap{
    width: 100%;
    height: auto;
    padding-bottom: 1.944444rem;
  }
  .mobile_itemimg_view{
    width: 88.89%;
    height: auto;
    margin: 1.944444rem auto 0 auto;
  }
  .mobile_itemimg_view img{
    display: block;
    width: 100%;
  }
  .mobile_viewrap .lalanitaaviso_1v{
    width: 80vw;
    box-sizing: border-box;
    padding: 40px 0 0 0;
    margin: 0 auto;
  }
  .mobile_viewrap .lalanitaaviso_1vhea{
    font-size: 20px;
    height: auto;
  }
  .mobile_viewrap .lalanitaaviso_1v{
    width: 80vw;
  }
  .mobile_viewrap .lalanitaaviso_2v{
    width: 80vw;
    height: auto;
  }
  .mobile_viewrap .lalanitaaviso_2v_v{
    width: 100%;
  }
  .mobile_viewrap .lalanitaaviso_1vtx{
    padding: 0;
  }
  .mobile_viewrap .lalanitaaviso_1vtx_s{
    font-size: 12px;
    line-height: 20px;
  }
  .mobile_viewrap .lalanitaaviso_1vms{
    font-size: 12px;
    line-height: 20px;
    padding: 20px 0;
  }
  .mobile_viewrap .lalanitaaviso_2v_v{
    width: 100%;
    height: auto;
    padding: 10px;
  }
  .mobile_viewrap .lalanitaaviso_2v_vh{
    width: 100%;
    height: auto;
    font-size: 12px;
    line-height: 20px;
  }
  .mobile_viewrap .lalanitaaviso_2v_vd{
    width: 100%;
  }
  .mobile_viewrap .lalanitaaviso_2v_vd_v{
    font-size: 12px;
    line-height: 20px;
  }
  .lalanitaaviso_1v{
    width: 1240px;
    height: auto;
    box-sizing: border-box;
    padding: 188px 0 0 0;
    margin: 0 auto;
  }
  .lalanitaaviso_1vhea{
    width: 100%;
    height: 187px;
    font-family: MiSans, MiSans;
    font-weight: 600;
    font-size: 58px;
    color: #383A39;
    line-height: 68px;
    text-align: center;
    font-style: normal;
  }
  .lalanitaaviso_1vtx{
    width: 100%;
    height: auto;
    margin: 0 auto;
    background: linear-gradient( 180deg, #FFF8F6 0%, #FFF5F1 100%);
    border-radius: 48px;
    box-sizing: border-box;
    padding: 63px 80px;
  }
  .lalanitaaviso_1vtx_s{
    width: 100%;
    font-size: 28px;
    color: #383A39;
    line-height: 46px;
    text-align: left;
    font-style: normal;
  }
  .lalanitaaviso_1vms{
    width: 100%;
    height: auto;
    box-sizing: border-box;
    padding: 95px 100px 120px 100px;
    font-weight: 400;
    font-size: 24px;
    color: #FF7648;
    line-height: 34px;
    text-align: center;
    font-style: normal;
  }
  .lalanitaaviso_2v{
    width: 1240px;
    height: 620px;
    margin: 0 auto;
    position: relative;
  }
  .lalanitaaviso_2v_v{
    width: 1140px;
    height: 422px;
    background: #F8F8F8;
    border-radius: 40px;
    box-sizing: border-box;
    padding: 80px 132px 0 96px;
  }
  .lalanitaaviso_2v_vh{
    width: 100%;
    height: 124px;
    font-weight: 400;
    font-size: 28px;
    color: #444444;
    line-height: 46px;
    text-align: left;
    font-style: normal;
  }
  .lalanitaaviso_2v_vd{
    width: 434px;
    height: auto;
  }
  .lalanitaaviso_2v_vd_v{
    width: 100%;
    height: auto;
    font-weight: 400;
    font-size: 28px;
    color: #444444;
    line-height: 46px;
    text-align: left;
    font-style: normal;
  }
  .lalanitaaviso_2v_vmg{
    width: 700px;
    height: 300px;
    position: absolute;
    right: 0;
    bottom: 120px;
  }
  .lalanitaaviso_2v_vmg img{
    display: block;
    width: 700px;
    height: 300px;
  }
  .lalanitaaviso_2v_vmg_circle{
    width: 102px;
    height: 102px;
    position: absolute;
    right: 30px;
    bottom: 383px;
    background: url('../assets/imgs/lalanitaaviso_2v_2.webp') no-repeat center center;
    background-size: 100% 100%;
    animation: rotateAnimation 2s linear infinite;
  }
  .lalanitaaviso_2v_vmg_cicon{
    width: 102px;
    height: 102px;
    position: absolute;
    right: 30px;
    bottom: 383px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  .lalanitaaviso_2v_vmg_cirv{
    width: 55px;
    height: 50px;
  }
  .lalanitaaviso_2v_vmg_cirv img{
    display: block;
    width: 55px;
    height: 50px;
  }
</style>
